import {createContext, useContext, useState} from 'react';
import type {FilesItem} from 'store/slices/files/types';

interface AttachAndScopeContextType {
  scopeFiles: FilesItem[];
  setScopeFiles: (files: FilesItem[]) => void;
  attachFiles: FilesItem[];
  setAttachFiles: (files: FilesItem[]) => void;
}

const AttachAndScopeContext = createContext<
  AttachAndScopeContextType | undefined
>(undefined);

export function AttachAndScopeProvider({
  children,
}: {children: React.ReactNode}) {
  const [scopeFiles, setScopeFiles] = useState<FilesItem[]>([]);
  const [attachFiles, setAttachFiles] = useState<FilesItem[]>([]);

  return (
    <AttachAndScopeContext.Provider
      value={{scopeFiles, setScopeFiles, attachFiles, setAttachFiles}}>
      {children}
    </AttachAndScopeContext.Provider>
  );
}

export function useAttachAndScope() {
  const context = useContext(AttachAndScopeContext);
  if (context === undefined) {
    throw new Error(
      'useAttachAndScope must be used within a AttachAndScopeProvider',
    );
  }
  return context;
}
